<template>
  <v-card flat class="pb-5">
    <v-toolbar v-show="dataLoaded">
      <v-toolbar-title>Detalii</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon flat :color="light ? 'blue-grey' : 'grey lighten-2'" @click="_cbResetAll" :ripple="false" :disabled="user.dummy">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <!-- <v-scale-transition> -->
        <v-btn icon flat :color="light ? 'blue-grey' : 'grey lighten-2'" v-show="isEdited" @click="_cbUndoAll" :ripple="false" :disabled="user.dummy">
          <v-icon>mdi-undo</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      <!-- </v-scale-transition> -->
      <!-- <v-scale-transition> -->
        <v-btn icon flat :color="light ? 'blue-grey' : 'grey lighten-2'" v-show="isEdited" @click="save" :ripple="false" :disabled="user.dummy">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      <!-- </v-scale-transition> -->
      <!-- <v-spacer></v-spacer> -->
      <!-- <v-scale-transition> -->
        <!-- <v-progress-circular
          indeterminate
          size="18"
          width="2"
          :color="light ? 'blue-grey' : 'grey lighten-2'"
          v-show="loading">
        </v-progress-circular> -->
      <!-- </v-scale-transition> -->
      <v-btn icon flat :color="light ? 'blue-grey' : 'grey lighten-2'" @click.stop="_cbRefresh" :ripple="false">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn icon flat :color="light ? 'blue-grey' : 'grey lighten-2'" @click.stop="_cbOpenSettings" :ripple="false">
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-1" v-if="entityObject" v-show="dataLoaded">

      <v-card class="content-visibility-auto mb-2" v-if="(entityObject.repozare === 'Da' && !user.admin) || user.admin">
        <v-card-title class="accent--text title">Repozare</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <template v-if="user && !user.admin">
            <v-alert type="warning" :value="entityObject.repozare === 'Da'">
              {{ entityObject.repozare_text }}
            </v-alert>
          </template>
          <template v-else>
            <v-textarea
              @input="setField($event, 'repozare_text')"
              :value="entityObject.repozare_text"
              :auto-grow="false"
style="padding-right: 12px"
              :rows="4"
              hide-details
              hint="Observatii repozare"
              persistent-hint
              :disabled="!user.admin"
              solo flat>
            </v-textarea>
            <v-radio-group
              row
              v-model="entityObject.repozare"
              hint="Necesita repozare?"
              persistent-hint
              :disabled="!user.admin">
              <v-radio label="Da" value="Da" :ripple="false"></v-radio>
              <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
            </v-radio-group>
            <div class="v-messages mt-2">
              <v-icon small>mdi-calendar</v-icon>
              {{ entityObject.repozare_data ? new Date(entityObject.repozare_data).toLocaleString('ro-RO') : '-' }}
            </div>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="content-visibility-auto mb-2">
        <v-card-title class="accent--text title">User</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <v-icon small>mdi-account</v-icon>
          {{ entityObject.user ? entityObject.user : '-' }}
        </v-card-text>
      </v-card>

      <v-card class="content-visibility-auto mb-2" v-if="visibleFields.includes('info obiectiv')">
        <v-card-title class="accent--text title">Info obiectiv</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <v-system-bar window class="px-1">ID</v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                :value="entityObject._id"
                hint="ID in baza de date, folosit doar de catre aplicatie"
                disabled
                persistent-hint
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Eticheta &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('eticheta')" @click="undo('eticheta')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-select
                :items="labels"
                hint="Folosita la gruparea simbolurilor / poi-urilor in calupuri. Editabil doar de catre admin."
                v-model="entityObject.eticheta"
                :item-text="etichetaText"
                item-value="label"
                :disabled="!user.admin"
                persistent-hint
                :menu-props="{transition: false}"
                solo flat>
              </v-select>
            </v-card-text>
          </v-card>
          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Zona &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('zona')" @click="undo('zona')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-select
                :items="zones"
                hint="Folosita la gruparea simbolurilor / poi-urilor in zone. Editabil doar de catre admin."
                v-model="entityObject.zona"
                :item-text="zonaText"
                item-value="zona"
                :disabled="!user.admin"
                persistent-hint
                :menu-props="{transition: false}"
                solo flat>
              </v-select>
            </v-card-text>
          </v-card>

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              ID Asociatie &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('id_asociatie')" @click="undo('id_asociatie')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'id_asociatie')"
                :value="entityObject.id_asociatie"
                hint="ID in xlsx, folosit pentru a identifica in mod unic scara. Editabil doar de catre admin."
                :disabled="!user.admin"
                persistent-hint
                append-icon="mdi-refresh"
                @click:append="refreshIdAsociatie"
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card> -->
          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              ID Scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('id_scara')" @click="undo('id_scara')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'id_scara')"
                :value="entityObject.id_scara"
                hint="ID in xlsx, folosit pentru a identifica in mod unic adresa / poi-ul. Editabil doar de catre admin."
                :disabled="!user.admin"
                persistent-hint
                append-icon="mdi-refresh"
                @click:append="refreshIdScara"
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Adresa asociatie&nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('adresa_asociatie')" @click="undo('adresa_asociatie')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'adresa_asociatie')"
                :value="entityObject.adresa_asociatie"
                hint="Adresa asociatie de proprietari. Editabil de catre admin sau de catre user-ul care a adaugat poi-ul."
                :disabled="!user.admin && entityObject.addedBy !== user.username"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card> -->

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Adresa scara&nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('adresa')" @click="undo('adresa')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-2">
              <v-text-field
                @input="setField($event, 'adresa')"
                :value="entityObject.adresa"
                hint="Se genereaza pe baza informatiilor introduse mai jos."
                :readonly="true"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                >
              </v-text-field>

              <v-select
                @input="setField($event, 'tip_cladire')"
                :value="entityObject.tip_cladire"
                :items="['Bloc', 'Vila']"
                hint="Tip cladire"
                :disabled="user.dummy"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                >
              </v-select>

              <v-text-field
                @input="setField($event, 'nume_bloc')"
                :value="entityObject.nume_bloc"
                hint="Numele blocului (ex.: PC12)"
                :disabled="user.dummy"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                >
              </v-text-field>

              <v-text-field
                @input="setField($event, 'nume_scara')"
                :value="entityObject.nume_scara"
                hint="Nume / numar scara"
                :disabled="user.dummy"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"

                prefix="Sc.">
              </v-text-field>

              <v-select
                @input="setField($event, 'tip_strada')"
                :value="entityObject.tip_strada"
                :items="['Strada', 'Aleea', 'Bulevardul', 'Intrarea', 'Calea', 'Prelungirea', 'Soseaua']"
                hint="Tip strada"
                :disabled="user.dummy"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                >
              </v-select>

              <v-text-field
                @input="setField($event, 'nume_strada')"
                :value="entityObject.nume_strada"
                hint="Numele strazii"
                :disabled="user.dummy"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                >
              </v-text-field>

              <v-text-field
                @input="setField($event, 'nr_bloc')"
                :value="entityObject.nr_bloc"
                hint="Numarul blocului"
                :disabled="user.dummy"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                >
              </v-text-field>
            </v-card-text>
          </v-card>

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Adresa scara&nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('adresa')" @click="undo('adresa')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'adresa')"
                :value="entityObject.adresa"
                hint="Adresa asociata poi-ului. Editabil de catre admin sau de catre user-ul care a adaugat poi-ul."
                :disabled="!user.admin && entityObject.addedBy !== user.username"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card> -->

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii_scara')">mdi-close</v-icon>

              Observatii scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii_scara')" @click="undo('observatii_scara')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-textarea
                @input="setField($event, 'observatii_scara')"
                :value="entityObject.observatii_scara"
                :auto-grow="false"
style="padding-right: 12px"
                :rows="4"
                hide-details
                hint="Observatii la scara."
                persistent-hint
                solo flat
                :disabled="user.dummy">
              </v-textarea>
            </v-card-text>
          </v-card>
          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii')">mdi-close</v-icon>

              Observatii generale &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii')" @click="undo('observatii')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-textarea
                @input="setField($event, 'observatii')"
                :value="entityObject.observatii"
                :auto-grow="false"
style="padding-right: 12px"
                :rows="4"
                hide-details
                hint="Observatii generale."
                persistent-hint
                solo flat
                :disabled="user.dummy">
              </v-textarea>
            </v-card-text>
          </v-card> -->

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('reabilitat')">mdi-close</v-icon>
              Reabilitat &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('reabilitat')" @click="undo('reabilitat')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.reabilitat"
                hint="Cladire reabilitata?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
                <v-radio label="In curs" value="In curs" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <!-- <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('constructie_dupa_2005')">mdi-close</v-icon>
              Constructie dupa 2005 &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('constructie_dupa_2005')" @click="undo('constructie_dupa_2005')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.constructie_dupa_2005"
                hint="Cladire constructie_dupa_2005a?"
                persistent-hint
                :disabled="!user.admin">
                <v-radio label="Da" :value="true" :ripple="false"></v-radio>
                <v-radio label="Nu" :value="false" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card> -->

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('done')">mdi-close</v-icon>
              Obiectiv finalizat &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('done')" @click="undo('done')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.done"
                hint="S-a incheiat procesarea acestui obiectiv?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" :value="true" :ripple="false"></v-radio>
                <v-radio label="Nu" :value="false" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Centru geometric &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('centru_geometric')" @click="undo('centru_geometric')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <div style="width: 100%; height: 40vh">
                <GmapMap
                  :center="entityObject.centru_geometric"
                  :zoom="zoom"
                  :map-type-id="mapType"
                  :style="{ width: options.width, height: options.height }"
                  ref="map"
                  @zoom_changed="zoomChanged"
                  @maptypeid_changed="mapTypeChanged">

                  <GmapMarker
                    :position="entityObject.centru_geometric"
                    :draggable="!user.dummy"
                    @dragend="_cbDragEnd" />

                </GmapMap>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('checkedCoords')">mdi-close</v-icon>
              Coordonate verificate? &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('checkedCoords')" @click="undo('checkedCoords')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.checkedCoords"
                hint="Coordonatele de pe harta corespund cu realitatea?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" :value="true" :ripple="false"></v-radio>
                <v-radio label="Nu" :value="false" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="content-visibility-auto mb-2" v-if="visibleFields.includes('poze obiectiv')">
        <v-card-title class="accent--text title">Poze obiectiv</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <form ref="formobiectiv">
              <input type="file" ref="fileinputobiectiv" accept="image/*" multiple @change="filesAdded($event, 'obiectiv')" style="display: none">
            </form>
            <v-system-bar window class="px-1">
              Poze obiectiv &nbsp;
              <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                <template>
                  <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                  {{noOfEntityPhotos}}
                </template>
                <template>
                  <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                    <v-icon :color="entityFilesInQueue ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey-lighten-2')" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                    {{ entityFilesInQueue }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('obiectiv')" v-if="user && !user.dummy" :ripple="false">
                    <v-icon class="mr-0" :color="light ? 'primary' : 'primary lighten-2'">mdi-plus-circle</v-icon>
                  </v-btn>

                  <!-- mark bad photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="badEnabled ? 'warning' : (light ? 'blue-grey' : 'grey lighten-2')" class="mr-0">mdi-alert</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                    <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>

                  <!-- delete photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="deleteEnabled ? 'error' : (light ? 'blue-grey' : 'grey lighten-2')" class="mr-0">mdi-delete-circle</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                    <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>
                  <span v-show="deleteEnabled && toDelete.length">
                    {{toDelete.length}}
                  </span>

                </template>
              </div>
            </v-system-bar>
            <v-card-text class="pa-1">
              <template v-if="noOfEntityPhotos">
                <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                  <template>
                    <v-layout align-center justify-flex-start wrap>
                      <div style="display: flex; flex-wrap: wrap">
                        <template v-for="(photo, pIndex) in entityPhotos">
                          <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex" class="photo-div">
                            <v-avatar
                              size="48"
                              class="ma-1 viewerPhoto"
                              style="box-sizing: border-box">
                              <img
                                :src="serverURL + photo.replace('photos', 'thumbs')"
                                :data-src="serverURL + photo"
                                class="pa-1">
                            </v-avatar>
                            <div style="display: flex; justify-content: space-around; width: 100%">
                              <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                <v-icon small>mdi-download</v-icon>
                              </a>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                              <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                              <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                                <v-icon small>mdi-eye</v-icon>
                              </a>
                            </div>
                          </div>
                        </template>
                      </div>
                    </v-layout>
                  </template>
                </viewer>
                <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                  <!-- <v-scale-transition group> -->
                  <template v-for="(photo, pIndex) in entityPhotos">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex" class="photo-div">
                      <v-avatar
                        size="48"
                        class="ma-1"
                        :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                        style="box-sizing: border-box"
                        @click="selectPhoto(photo)">
                        <img
                          :src="serverURL + photo.replace('photos', 'thumbs')"
                          :data-src="serverURL + photo"
                          class="pa-1">
                      </v-avatar>
                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                      <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                    </div>
                  </template>
                  <!-- </v-scale-transition> -->
                </v-layout>
                <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                  <!-- <v-scale-transition group> -->
                  <template v-for="(photo, pIndex) in entityPhotos">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex" class="photo-div">
                      <v-avatar
                        size="48"
                        class="ma-1"
                        :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                        style="box-sizing: border-box"
                        @click="selectBadPhoto(photo)">
                        <img
                          :src="serverURL + photo.replace('photos', 'thumbs')"
                          :data-src="serverURL + photo"
                          class="pa-1">
                      </v-avatar>
                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                      <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                    </div>
                  </template>
                  <!-- </v-scale-transition> -->
                </v-layout>
              </template>
              <template v-else>
                Nu exista poze pentru obiectiv.
              </template>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="content-visibility-auto mb-2" v-if="visibleFields.includes('excel obiectiv') && (user.admin || user.excel)">
        <v-card-title class="accent--text title">Excel obiectiv</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <form ref="formexcel">
              <input type="file" ref="fileinputexcel" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple @change="excelsAdded($event, 'obiectiv')" style="display: none">
            </form>
            <v-system-bar window class="px-1">
              Excel obiectiv &nbsp;
              <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                <template>
                  <v-icon class="ml-1" color="primary" title="Excel-uri incarcate">mdi-file-excel</v-icon>
                  {{noOfEntityExcels}}
                </template>
                <template>
                  <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                    <v-icon :color="entityExcelsInQueue ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey-lighten-2')" class="mr-1" title="Excel-uri in asteptare">mdi-cloud-upload</v-icon>
                    {{ entityExcelsInQueue }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('excel')" v-if="user && !user.dummy" :ripple="false">
                    <v-icon class="mr-0" :color="light ? 'primary' : 'primary lighten-2'">mdi-plus-circle</v-icon>
                  </v-btn>

                  <!-- mark bad photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleExcelsBadMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="badEnabledExcels ? 'warning' : (light ? 'blue-grey' : 'grey lighten-2')" class="mr-0">mdi-alert</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBadExcels" v-show="badEnabledExcels && toBadExcels.length" :ripple="false">
                    <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>

                  <!-- delete photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteModeExcels" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="deleteEnabledExcels ? 'error' : (light ? 'blue-grey' : 'grey lighten-2')" class="mr-0">mdi-delete-circle</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeleteExcels" v-show="deleteEnabledExcels && toDeleteExcels.length" :ripple="false">
                    <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>
                  <span v-show="deleteEnabledExcels && toDeleteExcels.length">
                    {{toDeleteExcels.length}}
                  </span>

                </template>
              </div>
            </v-system-bar>
            <v-card-text class="pa-1">
              <template v-if="noOfEntityExcels">
                <div v-if="!deleteEnabledExcels && !badEnabledExcels">
                  <template>
                    <v-layout align-center justify-flex-start wrap>
                      <div style="display: flex; flex-wrap: wrap">
                        <template v-for="(excel, pIndex) in entityExcels">
                          <div style="display: flex; flex-direction: column; align-items: center; width: 64px" class="ma-2" :key="excel + pIndex">
                            <v-avatar
                              size="48"
                              class="ma-1 viewerPhoto"
                              style="box-sizing: border-box">
                              <v-icon large color="green">mdi-file-excel</v-icon>
                            </v-avatar>
                            <div style="display: flex; justify-content: space-around; width: 100%; flex-direction: column; align-items: center">
                              <a :href="serverURL + excel + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca fisier Excel">
                                <v-icon small>mdi-download</v-icon>
                              </a>
                              <v-icon small color="warning" v-if="excel.includes('_badexcel')">mdi-alert</v-icon>
                              <div class="filename-truncation" :title="excel.split('/').pop()">{{ excel.split('/').pop() }}</div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </v-layout>
                  </template>
                </div>
                <v-layout v-if="deleteEnabledExcels" align-center justify-flex-start wrap>
                  <div style="display: flex; flex-wrap: wrap">
                    <template v-for="(excel, pIndex) in entityExcels">
                      <div style="display: flex; flex-direction: column; align-items: center; width: 64px" class="ma-2" :key="excel + pIndex">
                        <v-avatar
                          size="48"
                          class="ma-1"
                          :class="{ 'deleteExcel': toDeleteExcels.includes(excel), 'normalExcel': !toDeleteExcels.includes(excel) }"
                          style="box-sizing: border-box"
                          @click="selectExcel(excel)">
                          <v-icon large :color="toDeleteExcels.includes(excel) ? 'white' : 'green'">mdi-file-excel</v-icon>
                        </v-avatar>
                        <div style="display: flex; justify-content: space-around; width: 100%; flex-direction: column; align-items: center">
                          <v-icon small color="warning" v-if="excel.includes('_badexcel')">mdi-alert</v-icon>
                          <div class="filename-truncation" :title="excel.split('/').pop()">{{ excel.split('/').pop() }}</div>
                        </div>
                      </div>
                    </template>
                  </div>
                </v-layout>
                <v-layout v-if="badEnabledExcels" align-center justify-flex-start wrap>
                  <div style="display: flex; flex-wrap: wrap">
                    <template v-for="(excel, pIndex) in entityExcels">
                      <div style="display: flex; flex-direction: column; align-items: center; width: 64px" class="ma-2" :key="excel + pIndex">
                        <v-avatar
                          size="48"
                          class="ma-1"
                          :class="{ 'badExcel': toBadExcels.includes(excel), 'normalExcel': !toBadExcels.includes(excel) }"
                          style="box-sizing: border-box"
                          @click="selectBadExcel(excel)">
                          <v-icon large :color="toBadExcels.includes(excel) ? 'white' : 'green'">mdi-file-excel</v-icon>
                        </v-avatar>
                        <div style="display: flex; justify-content: space-around; width: 100%; flex-direction: column; align-items: center">
                          <v-icon small color="warning" v-if="excel.includes('_badexcel')">mdi-alert</v-icon>
                          <div class="filename-truncation" :title="excel.split('/').pop()">{{ excel.split('/').pop() }}</div>
                        </div>
                      </div>
                    </template>
                  </div>
                </v-layout>
              </template>
              <template v-else>
                Nu exista fisier Excel pentru obiectiv.
              </template>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="content-visibility-auto mb-2" v-if="visibleFields.includes('info lift')">
        <v-card-title class="accent--text title">Info lift/lifturi</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_lift_scara')">mdi-close</v-icon>

              Nr lift scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_lift_scara')" @click="undo('nr_lift_scara')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.nr_lift_scara"
                hint="Nr lifturi pe scara."
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="0" :value="0" :ripple="false"></v-radio>
                <v-radio label="1" :value="1" :ripple="false"></v-radio>
                <v-radio label="2" :value="2" :ripple="false"></v-radio>
                <v-radio label="3" :value="3" :ripple="false"></v-radio>
                <v-radio label="4" :value="4" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-tabs color="transparent" slider-color="accent" hide-slider v-if="entityObject.nr_lift_scara">
            <v-tab
              v-for="n in entityObject.nr_lift_scara"
              :key="n"
              :ripple="false">
              Lift {{ n }}
            </v-tab>

            <v-tab-item
              v-for="n in entityObject.nr_lift_scara"
              :key="n"
              :transition="false"
              :reverse-transition="false">
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-card class="mb-3">
                    <form :ref="'formlift'+n">
                      <input type="file" :ref="'fileinputlift'+n" accept="image/*" multiple @change="filesAdded($event, `lift${n}`)" style="display: none">
                    </form>
                    <v-system-bar window class="px-1">
                      Poze &nbsp;<span class="accent--text">lift {{n}}</span> &nbsp;
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                        <template>
                          <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                          {{noOfLiftPhotos(n)}}
                        </template>
                        <template>
                          <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                            <v-icon :color="liftFilesInQueue(n) ? (light ? 'primary' : 'primary lighten-2') : (light ? 'blue-grey' : 'grey-lighten-2')" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                            {{ liftFilesInQueue(n) }}
                          </v-btn>

                          <v-spacer></v-spacer>
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto(`lift${n}`)" v-if="user && !user.dummy" :ripple="false">
                            <v-icon class="mr-0" :color="light ? 'primary' : 'primary lighten-2'">mdi-plus-circle</v-icon>
                          </v-btn>

                          <!-- mark bad photos -->
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                            <v-icon :color="badEnabled ? 'warning' : (light ? 'blue-grey' : 'grey lighten-2')" class="mr-0">mdi-alert</v-icon>
                          </v-btn>
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                            <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                          </v-btn>

                          <!-- mark delete photos -->

                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                            <v-icon :color="deleteEnabled ? 'error' : (light ? 'blue-grey' : 'grey lighten-2')" class="mr-0">mdi-delete-circle</v-icon>
                          </v-btn>
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                            <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                          </v-btn>
                          <span v-show="deleteEnabled && toDelete.length">
                            {{toDelete.length}}
                          </span>

                        </template>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <template v-if="noOfLiftPhotos(n)">
                        <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                          <template>
                            <v-layout align-center justify-flex-start wrap>
                              <div style="display: flex; flex-wrap: wrap">
                                <template v-for="(photo, pIndex) in liftPhotos(n)">
                                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex" class="photo-div">
                                    <v-avatar
                                      size="48"
                                      class="ma-1 viewerPhoto"
                                      style="box-sizing: border-box">
                                      <img
                                        :src="serverURL + photo.replace('photos', 'thumbs')"
                                        :data-src="serverURL + photo"
                                        class="pa-1">
                                    </v-avatar>
                                    <div style="display: flex; justify-content: space-around; width: 100%">
                                      <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                        <v-icon small>mdi-download</v-icon>
                                      </a>
                                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                                      <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                                      <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                                        <v-icon small>mdi-eye</v-icon>
                                      </a>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </v-layout>
                          </template>
                        </viewer>
                        <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                          <!-- <v-scale-transition group> -->
                          <template v-for="(photo, pIndex) in liftPhotos(n)">
                            <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex" class="photo-div">
                              <v-avatar
                                size="48"
                                class="ma-1"
                                :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                                style="box-sizing: border-box"
                                @click="selectPhoto(photo)">
                                <img
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  :data-src="serverURL + photo"
                                  class="pa-1">
                              </v-avatar>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                              <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                            </div>
                          </template>
                          <!-- </v-scale-transition> -->
                        </v-layout>
                        <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                          <!-- <v-scale-transition group> -->
                          <template v-for="(photo, pIndex) in liftPhotos(n)">
                            <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex" class="photo-div">
                              <v-avatar
                                size="48"
                                class="ma-1"
                                :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                                style="box-sizing: border-box"
                                @click="selectBadPhoto(photo)">
                                <img
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  :data-src="serverURL + photo"
                                  class="pa-1">
                              </v-avatar>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                              <v-icon small color="error" v-if="photo.includes('_repozare_')" :title="getRepozareDate(photo)">mdi-alpha-r-circle-outline</v-icon>
                            </div>
                          </template>
                          <!-- </v-scale-transition> -->
                        </v-layout>
                      </template>
                      <template v-else>
                        Nu exista poze pentru {{`lift ${n}`}}.
                      </template>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii', 'info_lift', n-1)">mdi-close</v-icon>

                      Observatii &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii', 'info_lift', n-1)" @click="undo('observatii', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('observatii', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['observatii']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-textarea
                        @input="setField($event, 'observatii', 'info_lift', n-1, false)"
                        :value="entityObject.info_lift[n-1].observatii"
                        :auto-grow="false"
style="padding-right: 12px"
                        :rows="4"
                        hide-details
                        hint="Observatii"
                        persistent-hint
                        :disabled="user.dummy"
                        solo flat>
                      </v-textarea>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>

      <v-dialog class="content-visibility-auto" v-model="dialog" scrollable :transition="false" no-click-animation hide-overlay>
        <v-card>
          <v-card-title class="headline primary white--text">
            Setari vizibilitate campuri
          </v-card-title>

          <v-card-text>
            <v-switch
              v-model="visibleFields"
              v-for="field in fields"
              :key="field"
              :label="field"
              :value="field"
              :ripple="false">
            </v-switch>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="_cbCloseSettings(0)" :ripple="false">
              Inchide
            </v-btn>
            <v-btn color="primary" flat @click="_cbCloseSettings(1)" :ripple="false">
              Salveaza
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>

    <v-speed-dial v-model="fab" bottom right direction="top" style="position: fixed; bottom: 57px;" v-show="dataLoaded">
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" fab>
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </template>
      <v-btn fab small color="blue-grey" @click="_cbResetAll" :ripple="false" :disabled="user.dummy" dark>
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn fab small color="blue-grey" v-show="isEdited" @click="_cbUndoAll" :ripple="false" :disabled="user.dummy" dark>
          <v-icon>mdi-undo</v-icon>
        </v-btn>
      <v-btn fab small color="blue-grey" v-show="isEdited" @click="save" :ripple="false" :disabled="user.dummy" dark>
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      <v-btn fab small color="blue-grey" @click.stop="_cbRefresh" :ripple="false" dark>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn fab small color="blue-grey" @click.stop="_cbOpenSettings" :ripple="false" dark>
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </v-speed-dial>

    <div style="text-align: center">
      <div class="pt-5 data-loading" style="text-align: center" v-if="!dataLoaded">
        <img src="/logo.png" alt="loader-logo" style="width:24px">
      </div>
      <v-btn fab flat large @click="_cbRefresh" :ripple="false" v-if="!dataLoaded">
        <v-icon color="primary">mdi-refresh</v-icon>
      </v-btn>
    </div>

  </v-card>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import { component as Viewer } from 'v-viewer'
// import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
import cloneDeep from 'lodash.clonedeep'
import uniqid from 'uniqid'

export default {
  components: {
    Viewer
  },
  name: 'entity-details',
  props: {
    entity: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('entities/setActiveEntity', to.params.entity)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.isEdited) {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Exista modificari nesalvate! Esti sigur(a) ca vrei sa parasesti pagina?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, vreau sa raman!',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.commit('entities/setActiveEntity', null)
          this.$store.commit('setIsDetailsEdited', false)
          next()
        })
        .catch(() => {
          next(false)
        })
    } else if (this.entityObject.nr_lift_scara === null) {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Trebuie sa setezi un NUMAR DE LIFTURI! Esti sigur(a) ca vrei sa parasesti pagina?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, vreau sa raman!',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.commit('entities/setActiveEntity', null)
          this.$store.commit('setIsDetailsEdited', false)
          next()
        })
        .catch(() => {
          next(false)
        })
    } else if (this.entityObject.nr_lift_scara > 0 && !this.hasPhotosForAllLifturi()) {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Trebuie sa incarci poze pentru FIECARE LIFT IN PARTE! Esti sigur(a) ca vrei sa parasesti pagina?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, vreau sa raman!',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.commit('entities/setActiveEntity', null)
          this.$store.commit('setIsDetailsEdited', false)
          next()
        })
        .catch(() => {
          next(false)
        })
    } else {
      this.$store.commit('entities/setActiveEntity', null)
      next()
    }
  },
  data: () => ({
    dataLoaded: false,
    fab: false,
    collapsed: false,
    fields: ['info obiectiv', 'poze obiectiv', 'excel obiectiv', 'info lift'],
    entityObject: {
      __v: null,
      _id: null,
      id_scara: null,
      id_asociatie: null,
      addedBy: null,
      adresa: null,

      repozare: null,
      repozare_text: null,
      repozare_data: null,

      tip_cladire: null,
      nume_bloc: null,
      nume_scara: null,
      tip_strada: null,
      nume_strada: null,
      nr_bloc: null,

      reabilitat: null,
      // constructie_dupa_2005: null,

      adresa_asociatie: null,
      centru_geometric: { lat: 44.446086, lng: 26.063843 },
      createdAt: null,
      done: 'Nu',
      checkedCoords: 'Nu',
      eticheta: null,
      zona: null,
      info_lift: [

      ],
      nr_lift_scara: null,
      observatii: null,
      observatii_scara: null,
      pdfs: [],
      photos: [],
      updatedAt: null,
      user: null
    },
    deleteEnabled: false,
    toDelete: [],
    options: {
      width: '100%',
      height: '100%'
    },
    dialog: false,
    visibleFields: [],
    toDeletePdfs: [],
    deletePdfsEnabled: false,
    pdfDialog: false,
    pdfFrameSrc: '',
    pdfFrameTitle: '',
    badEnabled: false,
    toBad: [],

    badEnabledExcels: false,
    toBadExcels: [],
    deleteEnabledExcels: false,
    toDeleteExcels: []
  }),
  computed: {
    serverURL () {
      return this.$store.getters.serverURL
    },
    activeEntity () {
      return this.$store.getters['entities/activeEntity']
    },
    isEdited () {
      // This is true on mobile from the getgo
      // activeEntity should be null at first and then immediately change
      // works on desktop, does not work as expected on mobile
      // return false
      return JSON.stringify(this.activeEntity) !== JSON.stringify(this.entityObject)
    },
    // editedFields () { // ramas din primul fork al parcari_s4
    //   // return []
    //   // will have to refactor
    //   return this.fields.filter(field => {
    //     return JSON.stringify(this.activeEntity[field.value]) !== JSON.stringify(this.entityObject[field.value])
    //   }).map(field => field.value)
    // },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    entityFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'obiectiv').length
    },
    entityExcelsInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'excel' && file.parent === 'obiectiv').length
    },

    entityPdfsInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf' && file.parent === 'obiectiv').length
    },
    liftFilesInQueue () {
      return n => {
        return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === `lift${n}`).length
      }
    },
    liftPdfsInQueue () {
      return n => {
        return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf' && file.parent === `lift${n}`).length
      }
    },
    zoom () {
      return this.$store.getters.zoomDetailsPage
    },
    mapType () {
      return this.$store.getters.mapTypeDetailsPage
    },
    settings () {
      return this.$store.getters.settingsDetailsPage
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    entityPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('obiectiv'))
    },
    entityPdfs () {
      return !this.activeEntity ? [] : this.activeEntity.pdfs.filter(pdf => pdf.includes('obiectiv'))
    },
    noOfEntityPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_obiectiv_')) acc = acc + 1
        return acc
      }, 0)
    },
    noOfEntityExcels () {
      return !this.activeEntity ? 0 : this.activeEntity.excels.length
    },
    noOfEntityPdfs () {
      return !this.activeEntity ? 0 : this.activeEntity.pdfs.reduce((acc, pdf) => {
        if (pdf.includes('_obiectiv_')) acc = acc + 1
        return acc
      }, 0)
    },

    noOfLiftPhotos () {
      return n => {
        return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
          if (photo.includes(`_lift${n}_`)) acc = acc + 1
          return acc
        }, 0)
      }
    },
    noOfLiftPdfs () {
      return n => {
        return !this.activeEntity ? 0 : this.activeEntity.pdfs.reduce((acc, pdf) => {
          if (pdf.includes(`_lift${n}_`)) acc = acc + 1
          return acc
        }, 0)
      }
    },
    liftPhotos () {
      return n => {
        return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes(`lift${n}`))
      }
    },
    liftPdfs () {
      return n => {
        return !this.activeEntity ? [] : this.activeEntity.pdfs.filter(pdf => pdf.includes(`lift${n}`))
      }
    },
    entityExcels () {
      return !this.activeEntity ? [] : this.activeEntity.excels
    },
    light () {
      return this.$store.getters.light
    }
  },
  watch: {
    activeEntity: {
      deep: true,
      immediate: true,
      handler (obj) {
        // will have to refactor
        if (obj) {
          this.entityObject = Object.assign({}, cloneDeep(obj))
          this.$nextTick(() => {
            this.dataLoaded = true
          })
        } else {
          this.dataLoaded = false
          this.entityObject = Object.assign({}, {
            __v: null,
            _id: null,
            id_scara: null,
            id_asociatie: null,
            addedBy: null,
            adresa: null,

            repozare: null,
            repozare_text: null,
            repozare_data: null,

            tip_cladire: null,
            nume_bloc: null,
            nume_scara: null,
            tip_strada: null,
            nume_strada: null,
            nr_bloc: null,

            reabilitat: null,
            // constructie_dupa_2005: null,

            adresa_asociatie: null,
            centru_geometric: { lat: 44.446086, lng: 26.063843 },
            createdAt: null,
            done: 'Nu',
            checkedCoords: 'Nu',
            eticheta: null,
            zona: null,
            info_lift: [

            ],
            nr_lift_scara: null,
            observatii: null,
            observatii_scara: null,
            pdfs: [],
            photos: [],
            updatedAt: null,
            user: null
          })
        }
      }
    },
    settings: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          if (typeof val === 'string') this.visibleFields = val.split(',')
          else if (Array.isArray(val)) this.visibleFields = val.slice()
        }
      }
    },
    isEdited (v) {
      this.$store.commit('setIsDetailsEdited', v)
    },
    'entityObject.nr_lift_scara' (nv, ov) {
      this.updateInfoLift(nv, ov)
    },

    'entityObject.tip_cladire' (nv, ov) {
      this.$set(this.entityObject, 'adresa', `${this.entityObject.tip_cladire || ''} ${this.entityObject.nume_bloc || ''}, Sc. ${this.entityObject.nume_scara || ''}, ${this.entityObject.tip_strada || ''} ${this.entityObject.nume_strada || ''}, Nr. ${this.entityObject.nr_bloc || ''}`)
    },
    'entityObject.nume_bloc' (nv, ov) {
      this.$set(this.entityObject, 'adresa', `${this.entityObject.tip_cladire || ''} ${this.entityObject.nume_bloc || ''}, Sc. ${this.entityObject.nume_scara || ''}, ${this.entityObject.tip_strada || ''} ${this.entityObject.nume_strada || ''}, Nr. ${this.entityObject.nr_bloc || ''}`)
    },
    'entityObject.nume_scara' (nv, ov) {
      this.$set(this.entityObject, 'adresa', `${this.entityObject.tip_cladire || ''} ${this.entityObject.nume_bloc || ''}, Sc. ${this.entityObject.nume_scara || ''}, ${this.entityObject.tip_strada || ''} ${this.entityObject.nume_strada || ''}, Nr. ${this.entityObject.nr_bloc || ''}`)
    },
    'entityObject.tip_strada' (nv, ov) {
      this.$set(this.entityObject, 'adresa', `${this.entityObject.tip_cladire || ''} ${this.entityObject.nume_bloc || ''}, Sc. ${this.entityObject.nume_scara || ''}, ${this.entityObject.tip_strada || ''} ${this.entityObject.nume_strada || ''}, Nr. ${this.entityObject.nr_bloc || ''}`)
    },
    'entityObject.nume_strada' (nv, ov) {
      this.$set(this.entityObject, 'adresa', `${this.entityObject.tip_cladire || ''} ${this.entityObject.nume_bloc || ''}, Sc. ${this.entityObject.nume_scara || ''}, ${this.entityObject.tip_strada || ''} ${this.entityObject.nume_strada || ''}, Nr. ${this.entityObject.nr_bloc || ''}`)
    },
    'entityObject.nr_bloc' (nv, ov) {
      this.$set(this.entityObject, 'adresa', `${this.entityObject.tip_cladire || ''} ${this.entityObject.nume_bloc || ''}, Sc. ${this.entityObject.nume_scara || ''}, ${this.entityObject.tip_strada || ''} ${this.entityObject.nume_strada || ''}, Nr. ${this.entityObject.nr_bloc || ''}`)
    }
  },
  methods: {
    hasPhotosForAllLifturi () {
      let photos = true

      for (let index = 1; index <= this.entityObject.nr_lift_scara; index++) {
        if (this.noOfLiftPhotos(index) === 0 && this.liftFilesInQueue(index) === 0) {
          photos = false
        }
      }

      return photos
    },
    getRepozareDate (photo) {
      const uploadDate = new Date(+photo.split('_')[3]).toLocaleString('ro-RO')
      const repozareDate = photo.includes('_repozare_') ? new Date(+photo.substring(photo.indexOf('_repozare_') + 10, photo.lastIndexOf('.'))).toLocaleString('ro-RO') : 'Nope'

      return `Upload: ${uploadDate} - Repozare: ${repozareDate}`
    },
    selectPhoto (photo) {
      const index = this.toDelete.findIndex(p => p === photo)
      if (index > -1) {
        this.toDelete.splice(index, 1)
      } else {
        this.toDelete.push(photo)
      }
    },
    selectExcel (excel) {
      const index = this.toDeleteExcels.findIndex(p => p === excel)
      if (index > -1) {
        this.toDeleteExcels.splice(index, 1)
      } else {
        this.toDeleteExcels.push(excel)
      }
    },
    selectPdf (pdf) {
      const index = this.toDeletePdfs.findIndex(p => p === pdf)
      if (index > -1) {
        this.toDeletePdfs.splice(index, 1)
      } else {
        this.toDeletePdfs.push(pdf)
      }
    },
    _cbAddPhoto (type) {
      const ref = `fileinput${type}`
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePhotos', { entity: this.activeEntity._id, photos: this.toDelete })
          this.toDelete = []
        })
        .catch(() => {
        })
    },
    _cbToggleDeleteMode () {
      this.deleteEnabled = !this.deleteEnabled
      this.toDelete = []

      this.badEnabled = false
      this.toBad = []
    },
    async filesAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = `form${parent}`

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'photo', parent, idObiectiv: this.activeEntity.id_scara })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    async pdfsAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = `pdfform${parent}`

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'pdf', parent })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    async excelsAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = 'formexcel'

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'excel', parent })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    toggle () {
      this.collapsed = !this.collapsed
    },
    getType (fieldValue) {
      // not used anymore
      switch (fieldValue) {
        case 'eticheta': return 'select'

        case 'tip_cladire': return 'select'
        case 'nume_bloc': return 'text'
        case 'nume_scara': return 'text'
        case 'tip_strada': return 'select'
        case 'nume_strada': return 'text'
        case 'nr_bloc': return 'text'

        case 'repozare': return 'text'
        case 'repozare_text': return 'textarea'
        case 'repozare_data': return 'date'

        case 'reabilitat': return 'text'
        // case 'constructie_dupa_2005': return 'boolean'

        case 'zona': return 'select'
        case 'done': return 'boolean'
        case 'checkedCoords': return 'boolean'
        case 'id_scara': return 'text'
        case 'id_asociatie': return 'text'
        case 'adresa': return 'textarea'
        case 'adresa_asociatie': return 'textarea'
        case 'observatii': return 'textarea'
        case 'observatii_scara': return 'textarea'
        case 'centru_geometric': return 'map'
        case 'nr_lift_scara': return 'radio' // 0, 1, 2, 3, 4
        default: return false
      }
    },
    // getMin (fieldValue) {
    //   switch (fieldValue) {
    //     case 'nr_niveluri_vizibile': return 3
    //     // case 'nr_niveluri_comert_servicii': return 1
    //     case 'nr_apartamente_pe_scara': return 1
    //     // case 'nr_lift_scara': return 0
    //   }
    // },
    // getMax (fieldValue) {
    //   switch (fieldValue) {
    //     case 'nr_niveluri_vizibile': return 18
    //     // case 'nr_niveluri_comert_servicii': return 3
    //     case 'nr_apartamente_pe_scara': return 999
    //     // case 'nr_lift_scara': return 3
    //   }
    // },
    getOptions (fieldValue) {
      switch (fieldValue) {
        case 'done': return ['Da', 'Nu']
        case 'checkedCoords': return ['Da', 'Nu']
        case 'nr_lift_scara': return [0, 1, 2, 3, 4]
      }
    },
    // getRules (fieldValue) {
    //   switch (fieldValue) {
    //     case 'id_scara':
    //     case 'id_asociatie':
    //     case 'adresa':
    //     case 'adresa_asociatie':
    //     case 'centru_geometric':
    //     case 'nr_lift_scara':
    //     case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
    //     case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
    //     default: return []
    //   }
    // },
    save () {
      if (this.user.admin) {
        if (!this.entityObject.user) {
          this.entityObject.user = this.user.username
        }
      } else {
        this.entityObject.user = this.user.username
      }
      this.$store.dispatch('entities/save', this.entityObject)
    },

    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoomDetailsPage', $event)
    }, 1000),
    mapTypeChanged ($event) {
      this.$store.commit('setMapTypeDetailsPage', $event)
    },

    _cbDragEnd: debounce(function ($event) {
      if (!this.user.dummy) {
        this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Ai miscat pin-ul pe harta. Esti sigur ca vrei sa modifici coordonatele?'
          }, {
            okText: 'DA, modific!',
            cancelText: 'Nu, nu modific.',
            animation: 'zoom'
          })
          .then(dialog => {
            this.$set(this.entityObject, 'centru_geometric', { lat: $event.latLng.lat(), lng: $event.latLng.lng() })
          })
          .catch(() => {
            this.$set(this.entityObject, 'centru_geometric', { lat: this.entityObject.centru_geometric.lat, lng: this.entityObject.centru_geometric.lng })
          })
      }
    }, 1000),

    undo (field, parent = null, index = null) {
      if (this.user.dummy) return

      if (field === 'adresa') {
        // this.$set(this.entityObject, 'tip_cladire', this.activeEntity.tip_cladire || null)
        // this.$set(this.entityObject, 'nume_bloc', this.activeEntity.nume_bloc || null)
        // this.$set(this.entityObject, 'nume_scara', this.activeEntity.nume_scara || null)
        // this.$set(this.entityObject, 'tip_strada', this.activeEntity.tip_strada || null)
        // this.$set(this.entityObject, 'nume_strada', this.activeEntity.nume_strada || null)
        // this.$set(this.entityObject, 'nr_bloc', this.activeEntity.nr_bloc || null)
        this.$set(this.entityObject, 'adresa', this.activeEntity.adresa)

        return
      }

      if (field === 'nr_lift_scara') {
        this.entityObject.info_lift = this.activeEntity.info_lift.map(lift => cloneDeep(lift))
      }

      if (field === 'centru_geometric') {
        this.entityObject.centru_geometric.lat = this.activeEntity.centru_geometric.lat
        this.entityObject.centru_geometric.lng = this.activeEntity.centru_geometric.lng
      } else {
        if (!parent) {
          this.$set(this.entityObject, field, this.activeEntity[field])
        } else {
          if (this.entityObject[parent].disabled) return
          if (index !== null) {
            if (this.activeEntity[parent][index]) {
              this.$set(this.entityObject[parent][index], field, this.activeEntity[parent][index][field])
            } else {
              this.$set(this.entityObject[parent][index], field, null)
            }
          } else {
            this.$set(this.entityObject[parent], field, this.activeEntity[parent][field])
          }
        }
      }
    },

    _cbUndoAll () {
      if (this.user.dummy) return
      this.entityObject = Object.assign({}, cloneDeep(this.activeEntity))
    },

    _cbOpenSettings () {
      this.dialog = true
    },
    _cbCloseSettings (mode) {
      if (mode) {
        this.dialog = false
        this.$store.commit('setSettingsDetailsPage', this.visibleFields)
      } else {
        this.dialog = false
      }
    },

    _cbAddPdf (type) {
      const ref = `pdffileinput${type}`
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    _cbToggleDeletePdfsMode () {
      this.deletePdfsEnabled = !this.deletePdfsEnabled
      this.toDeletePdfs = []
    },
    _cbConfirmDeletePdfs () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva?'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePdfs', { entity: this.activeEntity._id, pdfs: this.toDeletePdfs })
          this.toDeletePdfs = []
        })
        .catch(() => {
        })
    },
    viewPdf (pdf, src) {
      this.pdfFrameSrc = src
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
      this.pdfDialog = true
    },
    // onWheel ($event) {
    //   if ($event.target.type === 'number') {
    //     $event.target.blur()
    //   }
    // },
    refreshIdScara () {
      if (this.user.admin) {
        this.entityObject.id_scara = uniqid()
      }
    },
    refreshIdAsociatie () {
      if (this.user.admin) {
        this.entityObject.id_asociatie = uniqid()
      }
    },
    isFieldEdited (field, parent = null, index = null) {
      // return false
      if (this.activeEntity) {
        if (parent) {
          // if (this.activeEntity[parent] === undefined) return false

          if (index !== null) {
            // eslint-disable-next-line
            if (!this.activeEntity[parent][index]) {
              if (field.includes('plastic')) {
                return Array.isArray(this.entityObject[parent][index][field]) && this.entityObject[parent][index][field].length === 0
              }
              return this.entityObject[parent][index][field] === null
            }
            return this.activeEntity[parent][index][field] !== this.entityObject[parent][index][field]
          } else {
            if (field.includes('plastic')) {
              return JSON.stringify(this.activeEntity[parent][field]) !== JSON.stringify(this.entityObject[parent][field])
            }
            return this.activeEntity[parent][field] !== this.entityObject[parent][field]
          }
        } else {
          if (field === 'centru_geometric') {
            return this.activeEntity[field].lat !== this.entityObject[field].lat || this.activeEntity[field].lng !== this.entityObject[field].lng
          } else {
            return this.activeEntity[field] !== this.entityObject[field]
          }
        }
      }
      return false
    },
    etichetaText (item) {
      return `${item.label} - ${item.data}`
    },
    zonaText (item) {
      return `${item.zona}`
    },
    updateInfoLift (newVal, oldVal) {
      // console.log('updateInfoLift')
      if (newVal === 0 || newVal === null) {
        this.$set(this.entityObject, 'info_lift', [
          {
            observatii: null
          },
          {
            observatii: null
          },
          {
            observatii: null
          },
          {
            observatii: null
          }
        ])
      } else {
        // 1 -> 0 -> 0
        // 2 -> 0 -> 0, 1
        // 3 -> 0 -> 0, 1, 2
        // 2 -> 1 -> 1
        // 3 -> 1 -> 1, 2
        // 3 -> 2 -> 2

        // console.log(newVal, oldVal)

        for (let i = newVal; i < oldVal; i++) {
          Object.keys(this.entityObject.info_lift[i]).forEach(key => {
            this.$set(this.entityObject.info_lift[i], key, null)
          })
        }
      }

      this.$set(this.entityObject, 'nr_lift_scara', newVal)
    },
    setField ($value, field, parent = null, index = null, number = false) {
      if (this.user.dummy) return
      if (parent) {
        if (index === null) {
          this[`set_${field}_${parent}`](number ? (isNaN($value) ? null : +$value) : $value)
        } else {
          this[`set_${field}_${parent}_${index}`](number ? (isNaN($value) ? null : +$value) : $value)
        }
      } else {
        this[`set_${field}`](number ? (isNaN($value) ? null : +$value) : $value)
      }
    },

    set_id_scara: debounce(function (value) {
      this.$set(this.entityObject, 'id_scara', value)
    }, 1000),
    set_id_asociatie: debounce(function (value) {
      this.$set(this.entityObject, 'id_asociatie', value)
    }, 1000),
    set_adresa: debounce(function (value) {
      this.$set(this.entityObject, 'adresa', value)
    }, 1000),

    set_repozare: debounce(function (value) {
      this.$set(this.entityObject, 'repozare', value)
    }, 1000),
    set_repozare_text: debounce(function (value) {
      this.$set(this.entityObject, 'repozare_text', value)
    }, 1000),

    set_tip_cladire: debounce(function (value) {
      this.$set(this.entityObject, 'tip_cladire', value)
    }, 1000),
    set_nume_bloc: debounce(function (value) {
      this.$set(this.entityObject, 'nume_bloc', value)
    }, 1000),
    set_nume_scara: debounce(function (value) {
      this.$set(this.entityObject, 'nume_scara', value)
    }, 1000),
    set_tip_strada: debounce(function (value) {
      this.$set(this.entityObject, 'tip_strada', value)
    }, 1000),
    set_nume_strada: debounce(function (value) {
      this.$set(this.entityObject, 'nume_strada', value)
    }, 1000),
    set_nr_bloc: debounce(function (value) {
      this.$set(this.entityObject, 'nr_bloc', value)
    }, 1000),

    set_adresa_asociatie: debounce(function (value) {
      this.$set(this.entityObject, 'adresa_asociatie', value)
    }, 1000),
    set_observatii: debounce(function (value) {
      this.$set(this.entityObject, 'observatii', value)
    }, 1000),
    set_observatii_scara: debounce(function (value) {
      this.$set(this.entityObject, 'observatii_scara', value)
    }, 1000),

    set_observatii_info_lift_0: debounce(function (value) {
      // console.log(value)
      this.$set(this.entityObject.info_lift[0], 'observatii', value)
    }, 1000),
    set_observatii_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'observatii', value)
    }, 1000),
    set_observatii_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'observatii', value)
    }, 1000),
    set_observatii_info_lift_3: debounce(function (value) {
      this.$set(this.entityObject.info_lift[3], 'observatii', value)
    }, 1000),

    copyInfo (field, index) {
      this.$set(this.entityObject.info_lift[index], field, this.entityObject.info_lift[index - 1][field])
    },

    resetField (field, parent = null, index = null) {
      if (this.user.dummy) return

      if (field === 'adresa') {
        this.$set(this.entityObject, 'tip_cladire', null)
        this.$set(this.entityObject, 'nume_bloc', null)
        this.$set(this.entityObject, 'nume_scara', null)
        this.$set(this.entityObject, 'tip_strada', null)
        this.$set(this.entityObject, 'nume_strada', null)
        this.$set(this.entityObject, 'nr_bloc', null)

        this.$set(this.entityObject, 'adresa', null)

        return
      }

      if (parent) {
        if (this.entityObject[parent].disabled) return
        if (index !== null) {
          this.$set(this.entityObject[parent][index], field, null)
        } else {
          if (field.includes('plastic')) {
            this.$set(this.entityObject[parent], field, [])
          } else {
            this.$set(this.entityObject[parent], field, null)
          }
        }
      } else {
        // console.log(field)
        if (field !== 'centru_geometric') {
          this.$set(this.entityObject, field, ['done', 'checkedCoords'].includes(field) ? false : null)
        }
      }
    },

    _cbResetAll () {
      if (this.user.dummy) return
      const fields = [
        { field: 'observatii_scara', parent: null, index: null },
        { field: 'observatii', parent: null, index: null },
        { field: 'done', parent: null, index: null },
        { field: 'checkedCoords', parent: null, index: null },
        { field: 'nr_lift_scara', parent: null, index: null },
        { field: 'adresa', parent: null, index: null },
        { field: 'reabilitat', parent: null, index: null },
        // { field: 'constructie_dupa_2005', parent: null, index: null },

        // { field: 'tip_cladire', parent: null, index: null },
        // { field: 'nume_bloc', parent: null, index: null },

        { field: 'observatii', parent: 'info_lift', index: 0 },
        { field: 'observatii', parent: 'info_lift', index: 1 },
        { field: 'observatii', parent: 'info_lift', index: 2 },
        { field: 'observatii', parent: 'info_lift', index: 3 }
      ]

      if (this.user.admin) {
        fields.push({ field: 'repozare', parent: null, index: null })
        fields.push({ field: 'repozare_text', parent: null, index: null })
        fields.push({ field: 'repozare_data', parent: null, index: null })
      }

      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Esti pe cale sa stergi toate informatiile editabile ale simbolului! Esti sigur ca doresti sa faci asta?'
        }, {
          okText: 'DA',
          cancelText: 'Nu',
          animation: 'zoom'
        })
        .then(dialog => {
          fields.forEach(field => {
            this.resetField(field.field, field.parent, field.index)
          })
        })
        .catch(() => {
        })
    },

    _cbConfirmBad () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este reversibila!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/badPhotos', { entity: this.activeEntity._id, photos: this.toBad })
          this.toBad = []
          this.badEnabled = false
        })
        .catch(() => {
        })
    },
    _cbToggleBadMode () {
      this.badEnabled = !this.badEnabled
      this.toBad = []
      this.deleteEnabled = false
      this.toDelete = []
    },
    selectBadPhoto (photo) {
      const index = this.toBad.findIndex(p => p === photo)
      if (index > -1) {
        this.toBad.splice(index, 1)
      } else {
        this.toBad.push(photo)
      }
    },
    selectBadExcel (excel) {
      const index = this.toBadExcels.findIndex(p => p === excel)
      if (index > -1) {
        this.toBadExcels.splice(index, 1)
      } else {
        this.toBadExcels.push(excel)
      }
    },

    _cbToggleSectionDisabled (section) {
      if (!this.user.dummy) {
        this.$set(this.entityObject[section], 'disabled', !this.entityObject[section].disabled)
      }
    },

    _cbRefresh () {
      this.dataLoaded = false
      this.$nextTick(() => {
        this.$store.dispatch('entities/setActiveEntity', this.$route.params.entity)
      })
    },

    _cbToggleExcelsBadMode () {
      this.badEnabledExcels = !this.badEnabledExcels
      this.toBadExcels = []
      this.deleteEnabledExcels = false
      this.toDeleteExcels = []
    },
    _cbConfirmBadExcels () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este reversibila!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/badExcels', { entity: this.activeEntity._id, excels: this.toBadExcels })
          this.toBadExcels = []
          this.badEnabledExcels = false
        })
        .catch(() => {
        })
    },
    _cbToggleDeleteModeExcels () {
      this.deleteEnabledExcels = !this.deleteEnabledExcels
      this.toDeleteExcels = []

      this.badEnabledExcels = false
      this.toBadExcels = []
    },
    _cbConfirmDeleteExcels () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deleteExcels', { entity: this.activeEntity._id, excels: this.toDeleteExcels })
          this.toDeleteExcels = []
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang="stylus">

</style>
